import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { useHistory } from "react-router-dom";

export const INTELLIGENT_REPORT_PATH = "/intelligent-report";

const IntelligentReportContext = createContext(null);

export const IntelligentReportProvider = ({ children }) => {
  const history = useHistory();
  const [session, setSession] = useState(null);

  const openReport = useCallback((report, returnTo = "/") => {
    setSession({ report, returnTo });
    history.push(INTELLIGENT_REPORT_PATH);
  }, [history]);

  const closeReport = useCallback(() => {
    const returnTo = session?.returnTo || "/";
    setSession(null);
    history.replace(returnTo);
  }, [history, session]);

  const value = useMemo(() => ({
    currentReport: session?.report || null,
    returnTo: session?.returnTo || "/",
    openReport,
    closeReport,
  }), [closeReport, openReport, session]);

  return (
    <IntelligentReportContext.Provider value={value}>
      {children}
    </IntelligentReportContext.Provider>
  );
};

export const useIntelligentReport = () => {
  const context = useContext(IntelligentReportContext);
  if (!context) {
    throw new Error("useIntelligentReport debe utilizarse dentro de IntelligentReportProvider");
  }
  return context;
};

